export default __webpack_public_path__ + "static/eeUXPjlz-f264cdd47cadd4b7eb1187edf513f34b.svg";